import React from "react";
import { Col, Row } from "react-bootstrap";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import DeviceOtherFormSkeleton from "./DeviceOtherFormSkeleton";
import "./DeviceOtherForm.scss";
import { Icon, IconButton } from "@mui/material";
import moment from "moment";

const DeviceDetailsForm = (props) => {
  const { t } = useTranslation();
  const { initialValues } = props;

  const showSceleton = !initialValues;

  const openContract = (el) => {
    const origin = window.location.origin;
    window.location.href = `${origin}/#/dashboard/rentcontract/${el?.uuid}`;
  };

  const openPriceList = (el) => {
    const origin = window.location.origin;
    window.location.href = `${origin}/#/dashboard/priceList/${el?.uuid}`;
  };

  const openLeasing = (el) => {
    const origin = window.location.origin;
    window.location.href = `${origin}/#/dashboard/leasing/${el?.uuid}`;
  };
  const createRentContractClient = (deviceOnContract) => {
    return deviceOnContract?.find(
      (el) =>
        !el?.existOnContractNo?.archive &&
        !el?.existOnContractNo?.deleted &&
        el?.existOnContractNo?.status?.status === "ACTIVE",
    )?.existOnContractNo;
  };

  const extendedInitialValues = {
    ...initialValues,
    rentContractClient: createRentContractClient(
      initialValues?.deviceOnContract,
    ),
    leasing:
      initialValues.leasingItems?.length > 0
        ? {
            ...initialValues.leasingItems[0].leasing,
            endDate: initialValues.leasingItems[0].leasing?.endDate
              ? moment(initialValues.leasingItems[0].leasing.endDate).format(
                  "DD-MM-YYYY",
                )
              : "",
          }
        : "",
  };

  return (
    <>
      {showSceleton && <DeviceOtherFormSkeleton />}

      {!showSceleton && (
        <Form initialValues={extendedInitialValues} onSubmit={() => {}}>
          {({ handleSubmit, values }) => (
            <form
              className="DeviceDetailsForm"
              onSubmit={handleSubmit}
              style={{ height: "100%" }}
            >
              <Row style={{ height: "100%" }}>
                <Col style={{ height: "100%" }}>
                  <Row style={{ height: "100%" }}>
                    <Col xs={8}>
                      <BMXSeparator title={t("global:device.other")} />
                      <Row>
                        <Col
                          className="d-flex ealign-items-centr"
                          xs={{ span: 6 }}
                        >
                          <Field
                            className="w-100"
                            name="rentContractClient.contractNo"
                            readOnly
                            label={`${t("global:device.rentContractClient")}`}
                            component={BMXTextField}
                            data-cy="printerModel"
                          />
                          {values?.rentContractClient ? (
                            <IconButton
                              className="mt-3"
                              style={{ width: "2rem", height: "2rem" }}
                              size="small"
                              onClick={() =>
                                openContract(values.rentContractClient)
                              }
                            >
                              <Icon className="primary text" fontSize={"small"}>
                                arrow_forward
                              </Icon>
                            </IconButton>
                          ) : null}
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          className="d-flex ealign-items-centr"
                          xs={{ span: 6 }}
                        >
                          <Field
                            className="w-100"
                            name="priceList.index"
                            readOnly
                            label={`${t("global:device.bid")}`}
                            component={BMXTextField}
                            data-cy="priceList"
                          />
                          {values?.priceList ? (
                            <IconButton
                              className="mt-3"
                              style={{ width: "2rem", height: "2rem" }}
                              size="small"
                              onClick={() => openPriceList(values.priceList)}
                            >
                              <Icon className="primary text" fontSize={"small"}>
                                arrow_forward
                              </Icon>
                            </IconButton>
                          ) : null}
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          className="d-flex ealign-items-centr"
                          xs={{ span: 6 }}
                        >
                          <Field
                            className="w-100"
                            name="leasing.leasingNumber"
                            readOnly
                            label={`${t("global:leasing.leasingNumber")}`}
                            component={BMXTextField}
                            data-cy="leasingNumber"
                          />
                          {extendedInitialValues.leasing ? (
                            <IconButton
                              className="mt-3"
                              style={{ width: "2rem", height: "2rem" }}
                              size="small"
                              onClick={() =>
                                openLeasing(extendedInitialValues.leasing)
                              }
                            >
                              <Icon className="primary text" fontSize={"small"}>
                                arrow_forward
                              </Icon>
                            </IconButton>
                          ) : null}
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          className="d-flex ealign-items-centr"
                          xs={{ span: 6 }}
                        >
                          <Field
                            className="w-100"
                            name="leasing.endDate"
                            readOnly
                            label={`${t("global:leasing.endDate")}`}
                            component={BMXTextField}
                            data-cy="endDate"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </form>
          )}
        </Form>
      )}
    </>
  );
};

export default compose(withRouter)(DeviceDetailsForm);
